module.exports = __webpack_public_path__ + "img/onsen_odd.b2e72527.svg";